import React from 'react';
import Slider, { Settings } from 'react-slick';

import { clsx } from 'clsx';

import styles from './SimpleSlider.scss';

type Props = {
  className?: string;
  children: any;
  settings: Settings;
};

const SimpleSlider = (props: Props) => {
  const { className, children, settings }: Props = props;

  return (
    <div className={clsx(styles.Slider, className)}>
      <Slider {...settings}>{children}</Slider>
    </div>
  );
};

export default SimpleSlider;
